(() => {
  const galleries = document.querySelectorAll('[data-ew-gallery]');
  galleries.forEach((gallery) => {
    const main = gallery.querySelector('[data-ew-gallery-main]');
    const buttons = gallery.querySelectorAll('[data-ew-gallery-src]');
    if (!main || !buttons.length) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        main.style.opacity = '0';
        window.setTimeout(() => {
          main.src = button.dataset.ewGallerySrc;
          main.alt = button.dataset.ewGalleryAlt || '';
          main.style.opacity = '1';
        }, 130);
      });
    });
  });

  const stickyBuy = document.querySelector('[data-ew-sticky-buy]');
  const primaryForm = document.querySelector('.ew-pdp-form');
  if (stickyBuy && primaryForm && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.1 });
    observer.observe(primaryForm);
  }

  const content = document.querySelector('#MainContent');
  if (content) {
    const textNodes = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = textNodes.nextNode())) {
      node.nodeValue = node.nodeValue
        .replaceAll('contact@sidane.org', 'contact@endswellhair.com')
        .replace('please call  or email us at', 'please email us at');
    }

    content.querySelectorAll('a[href="mailto:contact@sidane.org"]').forEach((link) => {
      link.href = 'mailto:contact@endswellhair.com';
    });
  }
})();
